import React from "react";
import { Icon } from "./Icon";

interface Linkedin32Props {
  size?: number;
  className?: string;
  color?: string;
}

export const Linkedin32: React.FC<Linkedin32Props> = ({
  size,
  className,
  color,
}) => {
  return (
    <Icon size={size} className={className} color={color}>
      <path d="M128 310.4h172.8v627.2h-172.8v-627.2z" />
      <path d="M304 169.6c0 47.717-40.115 86.4-89.6 86.4s-89.6-38.683-89.6-86.4c0-47.717 40.115-86.4 89.6-86.4s89.6 38.683 89.6 86.4z" />
      <path d="M659.2 310.4c-44.8 0-89.6 19.2-121.6 51.2v-51.2h-176v627.2h176v-393.6c0 0-6.4-80 89.6-80 57.6 0 86.4 32 86.4 80v396.8h185.6v-390.4c-3.2-214.4-179.2-240-240-240z" />
    </Icon>
  );
};
